export default __webpack_public_path__ + "static/media/login-screen.57abebf0.png";